import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import { useLocal } from 'hooks/useLocal'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

export const useLocalDetalhe = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)

  const params = useParams()
  const router = useRouter()
  const localService = useLocal()

  const [local, setLocal] = useState({})
  const [carregando, setCarregando] = useState(false)

  // Carregar dados do local
  useEffect(() => {
    if (params.id) {
      localService.listarLocal(params.id, setLocal, setCarregando)
    }
  }, [params.id])

  const handleClickExameSolicitado = useCallback((id) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`)
  }, [router])

  const handleClickVestigio = useCallback((id) => {
    router.history.push(`/casos/caso/vestigio/detalhar/${id}`)
  }, [router])

  const handleClickCadaver = useCallback((id) => {
    router.history.push(`/casos/caso/cadaver/detalhar/${id}`)
  }, [router])

  const handleClickCaso = useCallback((id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/detalhar/${id}`)
    }
  }, [router])

  return {
    local,
    setLocal,
    carregando,
    route,
    router,
    handleClickExameSolicitado,
    handleClickVestigio,
    handleClickCadaver,
    handleClickCaso,
  }
}
